import React from 'react';
import { render } from '@testing-library/react';
import { Banner } from './Banner';

describe('Banner', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Banner
				status="info"
				title="Banner Title"
				icon
				primaryActionName="Refresh"
				secondaryActionName="Check Status"
				data-auto-sel="automation-selector"
			>
				Short body text
			</Banner>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
